import React from "react";
import styled from "styled-components";
import ContactImg from "../assets/images/termites.jpeg";
import { Button } from "./Button";

const Contact = () => {
  return (
    <ContactContainer id="contact">
      <ContactContent>
        <h1>Contact Us</h1>
        <p>
          Email us below or call us at (985) 264-8247 for a free consultation.
        </p>
        <form
          name="contact"
          method="POST"
          data-netlify="true"
          onSubmit="submit"
          data-netlify-honeypot="bot-field"
        >
          <input type="hidden" name="form-name" value="contact" />
          <div hidden>
            <input name="bot-field" />
          </div>
          <FormWrap>
            <label>
              <input
                className="name"
                type="text"
                placeholder="Name"
                name="name"
                required
              />
            </label>
            <label>
              <input
                className="email"
                type="email"
                placeholder="Email"
                name="email"
                id="email"
                required
              />
            </label>
            <label for="phone">
              <input
                className="tel"
                type="tel"
                placeholder="Phone Number"
                name="phone"
                id="phone"
                required
              />
            </label>
            <label>
              <textarea
                id="message"
                className="message"
                name="message"
                placeholder="Message"
                required
              ></textarea>
            </label>
            <Button
              as="button"
              type="submit"
              primary="true"
              round="true"
              css={`
                height: 48px;

                @media screen and (max-width: 768px) {
                  width: 100%;
                  min-width: 350px;
                }

                @media screen and (max-width: 400px) {
                  width: 100%;
                  min-width: 250px;
                }
              `}
            >
              Submit
            </Button>
          </FormWrap>
        </form>
      </ContactContent>
      <ContactInfo></ContactInfo>
    </ContactContainer>
  );
};

export default Contact;

const ContactContainer = styled.div`
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.5) 35%,
      rgba(0, 0, 0, 0.1) 100%
    ),
    url(${ContactImg}) no-repeat center;
  background-size: cover;
  height: 650px;
  width: 100%;
  padding: 5rem calc((100vw - 1300px) / 2);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContactHeading = styled.div``;
const ContactWrapper = styled.div``;
const ContactContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    text-align: center;
    margin-bottom: 1rem;
    font-size: clamp(1rem, 5vw, 3rem);
    padding: 0 1rem;
    @media screen and (max-width: 768px) {
      font-size: 2rem;
    }
  }

  p {
    text-align: center;
    font-size: clamp(1rem, 2.5vw, 1.5rem);
    padding: 0 1rem;
    margin-bottom: 2rem;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  form {
    z-index: 10;
  }
`;
const ContactInfo = styled.div`
  p {
    text-align: center;
    font-size: clamp(1rem, 2.5vw, 1.5rem);
    padding: 0 1rem;
    margin-bottom: 2rem;
    text-decoration: none;

    a {
      text-decoration: none;
      color: white;
    }
    a {
      text-decoration: none;
      color: white;
    }
  }
`;

const FormWrap = styled.div`
  input {
    padding: 1rem 1.5rem;
    outline: none;
    width: 350px;
    height: 48px;
    border-radius: 10px;
    border: none;
    margin-right: 1rem;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  textarea {
    padding: 1rem 1.5rem;
    outline: none;
    width: 350px;
    height: 150px;
    border-radius: 10px;
    border: none;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    margin-bottom: 10px;
    margin-top: 10px;

    .message {
      height: 3rem;
    }
  }

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0 1rem;

    input {
      margin-bottom: 1rem;
      width: 100%;
      margin-right: 0;
    }
  }
`;
